import { gtmSendEvent } from "@wojo/analytics";
import { StoryblokImage } from "@wojo/storyblok";
import { Button, Text } from "@wojo/ui";
import React from "react";
import { TourHeroSummaryInfoModal } from "./TourHeroSummaryInfoModal";
import style from "./TourHeroSummaryInfo.module.scss";
import { useI18n } from "@wojo/localization";
import { TourClassLevelContent } from "../../../generated/graphql";
import cn from "clsx";

type TourHeroClassLevelItemProps = {
    classLevel: TourClassLevelContent;
};

export const TourHeroClassLevelItem: React.FC<TourHeroClassLevelItemProps> = ({
    classLevel,
}) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { productPage } = useI18n("productPage");

    return (
        <React.Fragment>
            <Text
                tag="div"
                className={cn(
                    style["summary-info-detail"],
                    style["summary-info-detail--class-level"],
                )}
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {classLevel.icon?.filename && (
                    <StoryblokImage
                        mobile={{
                            asset: classLevel.icon,
                        }}
                        style={{
                            height: "21px",
                            display: "grid",
                            marginRight: "var(--g-spacing-sm)",
                        }}
                    />
                )}
                <Button
                    variant="quiet"
                    onClick={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_action: "OPENED",
                                ga4_object: "MODAL",
                                modalId: "TripType",
                            },
                        });
                        setIsModalOpen(true);
                    }}
                >
                    {classLevel.name}
                </Button>
            </Text>
            <TourHeroSummaryInfoModal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_action: "CLOSED",
                            ga4_object: "MODAL",
                            modalId: "TripType",
                        },
                    });
                    setIsModalOpen(false);
                }}
                isOpen={isModalOpen}
                heading={classLevel.name ?? ""}
                description={classLevel.description ?? ""}
                icon={classLevel.icon}
                iconWidth="28px"
                accessibleTitle={productPage.tourHero.titles.classLevel.l()}
            />
        </React.Fragment>
    );
};
